import React, { Fragment, useEffect, useState } from "react";
import { useHistory, useParams } from "react-router-dom";
import Layout from "../layout";
import { productByCategory } from "../../admin/products/FetchApi";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCreditCard } from "@fortawesome/free-solid-svg-icons";
import { isWishReq, unWishReq, isWish } from "./Mixins";

const apiURL = process.env.REACT_APP_API_URL;

const Submenu = ({ category }) => {
  const history = useHistory();

  return (
    <section className="mx-4 mt-24 md:mx-12 md:mt-32 lg:mt-24">
      <div className="flex justify-between items-center flex-wrap border-b pb-2 border-gray-200">
        <div className="text-sm flex space-x-3 tracking-wide">
          <span
            className="text-gray-500 hover:text-yellow-600 cursor-pointer transition-all duration-300"
            onClick={() => history.push("/")}
          >
            Início
          </span>
          <span className="text-yellow-700 font-medium">{category}</span>
        </div>
        <svg
          className="w-4 h-4 text-yellow-600"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M13 5l7 7-7 7M5 5l7 7-7 7"
          />
        </svg>
      </div>
    </section>
  );
};

const AllProduct = ({ products }) => {
  const history = useHistory();
  const [wList, setWlist] = useState(JSON.parse(localStorage.getItem("wishList")) || []);
  const category = products?.[0]?.pCategory?.cName || "";

  return (
    <Fragment>
      <Submenu category={category} />
      <section className="m-4 md:mx-12 md:my-6 grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-6">
        {products?.length > 0 ? (
          products.map((item, index) => (
            <div
              key={index}
              className="relative bg-white rounded-2xl border border-gray-100 shadow-sm hover:shadow-md transition-all duration-300 overflow-hidden"
            >
              <div className="bg-gray-50 flex justify-center items-center h-44">
                <img
                  onClick={() => history.push(`/products/${item._id}`)}
                  src={`${apiURL}/uploads/products/${item.pImages[0]}`}
                  alt={item.pName}
                  className="h-full object-contain p-4 cursor-pointer"
                />
              </div>
              <div className="p-4">
  <div className="overflow-hidden whitespace-nowrap">
    <div className="inline-block animate-marquee text-gray-800 text-sm font-light tracking-wide">
      {item.pName}
    </div>
  </div>

  <div className="flex items-center space-x-2 mt-1">
    <span className="text-green-600 font-semibold text-xl">
      R${item.pPrice}
    </span>
    {item.pOffer && (
      <>
        <span className="line-through text-red-400 text-sm">R${item.pOffer}</span>
        <span className="text-yellow-500 text-xs font-semibold uppercase tracking-wide">Oferta</span>
      </>
    )}
  </div>

  <div className="text-black text-xs font-light mt-1 flex items-center">
    <FontAwesomeIcon icon={faCreditCard} className="mr-1 text-olive-600" />
    3x de R${(item.pPrice / 3).toFixed(2)} sem juros
  </div>
</div>
              <button
                onClick={() => history.push(`/products/${item._id}`)}
                className="w-full bg-olive-600 hover:bg-olive-700 text-white text-sm font-medium py-2 rounded-b-2xl transition-all duration-300 tracking-wide"
              >
                Comprar agora
              </button>
              <div className="absolute top-2 right-2">
                {!isWish(item._id, wList) ? (
                  <svg
                    onClick={(e) => isWishReq(e, item._id, setWlist)}
                    className="w-5 h-5 text-gray-300 hover:text-yellow-500 cursor-pointer transition"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="1.5"
                      d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z"
                    />
                  </svg>
                ) : (
                  <svg
                    onClick={(e) => unWishReq(e, item._id, setWlist)}
                    className="w-5 h-5 text-yellow-600 cursor-pointer transition"
                    fill="currentColor"
                    viewBox="0 0 20 20"
                  >
                    <path
                      fillRule="evenodd"
                      d="M3.172 5.172a4 4 0 015.656 0L10 6.343l1.172-1.171a4 4 0 115.656 5.656L10 17.657l-6.828-6.829a4 4 0 010-5.656z"
                      clipRule="evenodd"
                    />
                  </svg>
                )}
              </div>
            </div>
          ))
        ) : (
          <div className="col-span-full flex justify-center py-20 text-gray-500 text-lg tracking-wide">
            Nenhum produto encontrado nesta categoria.
          </div>
        )}
      </section>
    </Fragment>
  );
};

const PageComponent = () => {
  const [products, setProducts] = useState(null);
  const { catId } = useParams();

  useEffect(() => {
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const fetchData = async () => {
    try {
      const responseData = await productByCategory(catId);
      if (responseData?.Products) {
        setProducts(responseData.Products);
      }
    } catch (error) {
      console.error("Erro ao buscar produtos:", error);
    }
  };

  return <AllProduct products={products} />;
};

const ProductByCategory = () => (
  <Layout>
    <PageComponent />
  </Layout>
);

export default ProductByCategory;